"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = tslib_1.__importStar(require("react"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
require("./label.css");
/** Represents a caption for an item in a user interface. Label is not a component intented to be used alone.
 *  It’s used to create FormGroup and Fieldset. */
const Label = ({ type = 'label', optionalText, children, className, dataTest = 'label', ...other }) => {
    const classes = (0, classnames_1.default)('dsc-label', className);
    const optionalMarkup = optionalText && ((0, jsx_runtime_1.jsx)("span", { className: "dsc-label__optional", "data-test": "text", children: optionalText }));
    const labelMarkup = () => ((0, jsx_runtime_1.jsxs)("span", { className: "dsc-label__container", children: [children, " ", optionalMarkup] }));
    return React.createElement(type, { ...other, className: classes, 'data-test': dataTest }, labelMarkup());
};
exports.Label = Label;
exports.Label.displayName = 'Label';
//# sourceMappingURL=label.js.map